import type { SupportLocales } from '@/types/lang/locales'

export const supportEn: SupportLocales = {
    frequentlyAsked: 'Frequently asked questions',
    results: 'Matching results',
    yourQuestion: 'Ask your question here'
}
